import { Role } from '@/model/role';
import type { RouteRecordRaw } from 'vue-router';

const Customers = () => import('@/components/customers/Customers.vue');
const CustomerView = () => import('@/components/customers/CustomerView.vue');
const CustomersMerge = () =>
  import('@/components/customers/CustomersMerge.vue');

const customersRoutes: RouteRecordRaw[] = [
  {
    path: '/customers',
    name: 'Customers',
    component: Customers,
    meta: {
      role: Role.STAFF,
    },
  },
  {
    path: '/customers/view/:id',
    name: 'CustomersView',
    component: CustomerView,
    meta: {
      role: Role.STAFF,
    },
  },
  {
    path: '/customers/merge',
    name: 'CustomersMerge',
    component: CustomersMerge,
    meta: {
      role: Role.STAFF,
    },
  },
];

export default customersRoutes;
